import { render, staticRenderFns } from "./changelog_modal.vue?vue&type=template&id=2cd76608&scoped=true&"
import script from "./changelog_modal.vue?vue&type=script&lang=js&"
export * from "./changelog_modal.vue?vue&type=script&lang=js&"
import style0 from "./changelog_modal.vue?vue&type=style&index=0&id=2cd76608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd76608",
  null
  
)

export default component.exports